import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function MethodSection() {
  const { ref, style } = useScrollReveal({
    threshold: 0.1,
    distance: 32,
    duration: 800,
  });
  const { ref: refImg, style: styleImg } = useScrollReveal({
    threshold: 0.1,
    distance: 28,
    duration: 800,
    delay: 250,
  });

  return (
    <section className="w-full bg-white py-20 md:py-28 px-6 lg:px-[7%]">
      <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
        <div ref={ref} style={style} className="flex-1 max-w-xl">
          <span className="font-sans text-brand-gray-500 text-[11px] tracking-[0.2em] uppercase font-medium">
            El método
          </span>
          <h2 className="font-serif text-brand-black text-[clamp(1.8rem,4vw,2.8rem)] leading-[1.3] mt-4">
            Un sistema propio, no una lista de consejos
          </h2>
          <p className="font-sans text-brand-gray-600 text-base leading-relaxed mt-6">
            Anthony Sánchez ha desarrollado un método estructurado que va más
            allá de la asesoría de imagen tradicional. No se trata de seguir
            tendencias ni de imitar looks de revista. Se trata de construir un
            sistema visual coherente que refleje quién eres, dónde quieres
            llegar y cómo quieres ser percibido.
          </p>
          <p className="font-sans text-brand-gray-600 text-base leading-relaxed mt-4">
            El proceso combina análisis psicológico, evaluación de estilo de
            vida, auditoría de armario y definición de códigos de vestuario por
            contexto. Cada decisión está fundamentada. Cada prenda tiene un
            propósito. Nada queda al azar.
          </p>
          <div className="mt-8 flex items-center gap-4">
            <div className="w-12 h-12 rounded-full overflow-hidden bg-brand-gray-100 flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=elegant-male-fashion-designer-portrait-barcelona-sophisticated-man-minimal-background-warm-lighting-editorial-photography-soft-grain-texture-high-end-fashion&width=200&height=200&seq=205&orientation=squarish"
                alt="Anthony Sánchez"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div>
              <p className="font-sans text-brand-black text-sm font-medium">
                Anthony Sánchez
              </p>
              <p className="font-sans text-brand-gray-500 text-xs">
                Director creativo y fundador
              </p>
            </div>
          </div>
        </div>
        <div ref={refImg} style={styleImg} className="flex-1 w-full lg:max-w-xl">
          <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden bg-brand-gray-100">
            <img
              src="https://readdy.ai/api/search-image?query=private-fashion-consultation-session-atelier-barcelona-designer-working-with-client-fabric-samples-elegant-minimal-space-warm-natural-light-editorial-photography-soft-tones-luxury&width=1200&height=800&seq=201&orientation=landscape"
              alt="Consulta privada de asesoría de imagen"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}